import React from 'react';
import { Container, Eyebrow, Reveal } from './landing/primitives';

const partners = ['Nexus AI', 'Vertex Labs', 'Prisma Tech', 'Orbital', 'Quantum Co', 'Grid Systems'];

const TrustBar = () => (
  <section className="py-14 lg:py-16 border-t border-line" data-testid="trust-bar-section">
    <Container>
      <Reveal className="grid lg:grid-cols-12 gap-8 items-center">
        <Eyebrow className="lg:col-span-3">Trusted by engineering teams at</Eyebrow>
        <div className="lg:col-span-9 grid grid-cols-3 md:grid-cols-6 gap-y-6">
          {partners.map((name) => (
            <span
              key={name}
              className="text-sm sm:text-base font-heading font-medium tracking-tight text-content-3 hover:text-content transition-colors duration-300 cursor-default"
              data-testid={`trust-logo-${name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {name}
            </span>
          ))}
        </div>
      </Reveal>
    </Container>
  </section>
);

export default TrustBar;
